import { FragmentOf, readFragment } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { useMemo } from "react";
import {
  RichTextLinks,
  RichTextRenderOverrides,
  useRichTextRenderOptions,
} from "@hooks/useRichTextRenderOptions";
import {
  documentToReactComponents,
  Options,
} from "@contentful/rich-text-react-renderer";
import { Document as RichTextDocument } from "@contentful/rich-text-types";
import { DeepPartial } from "../../../types/DeepPartial";

export const RichText = ({
  content: maskedContentFragment,
  body: bodyProp,
  options: optionsProp,
  overrides,
}: {
  content?: FragmentOf<typeof RichEntryFragment> | null;
  body?: { json: unknown; links?: DeepPartial<RichTextLinks> } | null;
  options?: Options;
  overrides?: RichTextRenderOverrides;
}) => {
  const content = readFragment(RichEntryFragment, maskedContentFragment);
  const body = content?.body ?? bodyProp;

  const options = useMemo(
    () => ({
      options: optionsProp,
      overrides,
    }),
    [optionsProp, overrides]
  );

  const renderOptions = useRichTextRenderOptions(
    body?.links,
    options
  );

  const render = useMemo(
    () =>
      body?.json
        ? documentToReactComponents(body.json as RichTextDocument, renderOptions)
        : null,
    [body, renderOptions]
  );

  return render;
};
